import React, { Component } from 'react';
import Seo from './Seo';
import axios from 'axios';
import { withTranslation } from 'react-i18next';

import { Card } from "./ui/Card.tsx";
import { Button } from "./ui/button.tsx";
import { FaJava, FaAngular, FaReact, FaDocker, FaCheckCircle } from "react-icons/fa";
import { SiSpringboot } from "react-icons/si";
import { MdOutlineArchitecture } from "react-icons/md";
import { motion } from "framer-motion";

import { Navigate } from 'react-router-dom';

import '../css/aboutUs.css';

class about extends Component {
    constructor(props) {
        super(props)

        this.state = {
            skillValue: '',
            title: "curriculum vitae",
            profile: undefined,
            currentPage: 0,
            totalPages: 0,
            redirectToContactUs: false
        }
    }

    // redirect To ContactUs button
    redirectToContactUs=() =>{
        this.setState({redirectToContactUs: true});
    }

    // Component lifecycle: fetch profiles when the component is mounted
    componentDidMount() {
        console.log("aboutUs ----");
      
    }

    fetchProfiles = async (page = 0) => {
        try {
            const response = await axios.get(`http://localhost:8883/profil?page=${page}`);
            const data = response.data;
            this.setState({
                profile: data, // Assuming the response contains content field for profiles
                totalPages: data.total,
            });
        } catch (error) {
            
        }
    };
    prevProfile = () => {
       // Log before setting state
       // Update the currentPage and fetch profiles after state is updated
       this.setState(
           (prevState) => ({
               currentPage: prevState.currentPage === 0 ? prevState.totalPages - 1 : prevState.currentPage - 1// Increment the current page by 1
           }),
           () => {
               // This callback is executed after the state has been updated
               // Fetch the next profile (or any data based on the new currentPage)
               this.fetchProfiles(this.state.currentPage);
           }
       );
    };

    nextProfile = () => {
        // Log before setting state
        // Update the currentPage and fetch profiles after state is updated
        this.setState(
            (prevState) => ({
                currentPage: prevState.currentPage < prevState.totalPages - 1 ? prevState.currentPage + 1 : 0 // Increment the current page by 1
            }),
            () => {
                // This callback is executed after the state has been updated
                // Fetch the next profile (or any data based on the new currentPage)
                this.fetchProfiles(this.state.currentPage);
            }
        );
    };
    render() {
        if(this.state.redirectToContactUs){
            return <Navigate to="/contactUs"/>
        }
        const { t } = this.props;
        return (
            <div className="about-container">
                <Seo
                    title="À propos"
                    description="YB Technical Services accompagne les entreprises dans la conception de solutions logicielles robustes et modernes : Java, Spring, Angular, React."
                    path="/about"
                />

        
            <div className="max-w-4xl mx-auto p-6 text-center">
      <motion.h1 
        className="text-3xl font-bold mb-4" 
        initial={{ opacity: 0, y: -20 }} 
        animate={{ opacity: 1, y: 0 }}>
        {this.props.t('a_propos')}
      </motion.h1>
      <p className="text-gray-600 mb-6">
        {this.props.t('yb_description')}
      </p>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-6">
        {[ 
          { icon: FaJava, label: "Java" },
          {icon: SiSpringboot, label: "Springboot"},
          { icon: FaAngular, label: "Angular" },
          { icon: FaReact, label: "React" },
          { icon: FaDocker, label: "Docker" },
          { icon: MdOutlineArchitecture, label: this.props.t('logiciel_architecture') }
        ].map((tech, index) => (
          <Card key={index} className="p-4 flex flex-col items-center">
            <tech.icon className="text-4xl text-blue-500 mb-2" />
            <span className="text-sm font-semibold">{tech.label}</span>
          </Card>
        ))}
      </div>

       {/* Section Pourquoi Nous Choisir */}
       <div className="bg-gradient-to-r from-blue-500 to-purple-600 text-white p-8 rounded-lg shadow-lg mb-6">
        <h2 className="text-2xl font-bold mb-4">{this.props.t('our_engagement')}</h2>
        <p className="text-lg mb-4">
        {this.props.t('our_engagement_desc')}
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            { icon: FaCheckCircle, text: this.props.t('agile_dev') },
            { icon: FaCheckCircle, text: this.props.t('innov_solution') },
            { icon: FaCheckCircle, text: this.props.t('expertise') },
          ].map((item, index) => (
            <div key={index} className="flex items-center gap-3">
              <item.icon className="text-3xl text-yellow-400" />
              <span className="text-lg font-semibold">{item.text}</span>
            </div>
          ))}
        </div>
      </div>
      <div onClick={this.redirectToContactUs} className="contact-button">
        {this.props.t('contact_us')}
      </div>
    </div>
    </div>
        )
    }

}
export default withTranslation()(about);
